// app/javascript/sections/workforce_index_hero.js

document.addEventListener("DOMContentLoaded", function () {
    const hero = document.getElementById("workforce-hero");
    if (!hero) return;
    if (!("IntersectionObserver" in window)) return;

    // LEFT COLUMN
    const heading   = hero.querySelector(".hero-heading");
    const bodyCopy  = hero.querySelector(".hero-body");
    const ctaButton = hero.querySelector(".hero-cta");

    // RIGHT – DESKTOP
    const ipadDesktop     = hero.querySelector(".hero-ipad");
    const stintersDesktop = hero.querySelectorAll(".hero-stinter-img");
    const daniellaDesktop = hero.querySelector(".hero-daniella");

    // RIGHT – MOBILE
    const ipadMobile     = hero.querySelector(".hero-m-ipad");
    const stintersMobile = hero.querySelectorAll(".hero-m-stinter");
    const daniellaMobile = hero.querySelector(".hero-m-daniella");

    const animatedEls = [];

    function setup(el, baseClass, delaySeconds) {
        if (!el) return;
        el.classList.add(baseClass);
        el.style.transitionDelay = `${delaySeconds}s`;
        animatedEls.push(el);
    }

    // ===== TIMING SEQUENCE =====
    // Left:
    //   heading  0.00s
    //   body     0.25s
    //   button   0.50s   (all done ≈ 1s)
    setup(heading,   "hero-anim-left", 0.0);
    setup(bodyCopy,  "hero-anim-left", 0.25);
    setup(ctaButton, "hero-anim-left", 0.5);

    // iPad (desktop + mobile) after left column
    const ipadDelay = 0.7;
    setup(ipadDesktop, "hero-anim-ipad", ipadDelay);
    setup(ipadMobile,  "hero-anim-ipad", ipadDelay);

    // Stinters: start a bit after iPad, DOM order = top→bottom
    const stinterStart = 0.95;
    const stinterStep  = 0.18; // a bit slower stagger

    function setupStinters(list) {
        list.forEach((el, index) => {
            setup(el, "hero-anim-stinter", stinterStart + index * stinterStep);
        });
    }

    setupStinters(stintersDesktop);
    setupStinters(stintersMobile);

    // Daniella: after the LAST stinter has started + small buffer
    const count = Math.max(stintersDesktop.length, stintersMobile.length, 1);
    const lastStDelay   = stinterStart + (count - 1) * stinterStep;
    const daniellaDelay = lastStDelay + 0.3;

    setup(daniellaDesktop, "hero-anim-daniella", daniellaDelay);
    setup(daniellaMobile,  "hero-anim-daniella", daniellaDelay);

    function showAll() {
        animatedEls.forEach((el) => el.classList.add("is-visible"));
    }

    function hideAll() {
        animatedEls.forEach((el) => el.classList.remove("is-visible"));
    }

    const observer = new IntersectionObserver(
        (entries) => {
            const entry = entries[0];
            if (!entry || entry.target !== hero) return;

            const goingIn  = entry.isIntersecting && entry.intersectionRatio >= 0.4;
            const goingOut = !entry.isIntersecting || entry.intersectionRatio < 0.15;

            if (goingIn) {
                showAll();
            } else if (goingOut) {
                // reset so it can replay when you scroll back up
                hideAll();
            }
        },
        {
            threshold: [0, 0.15, 0.4, 0.8],
        }
    );

    observer.observe(hero);
});